import React, { Fragment, useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import NoPermission from "../../common/NoPermission";
import { useDispatch, useSelector } from "react-redux";
import LoaderSpinner from "../../common/LoaderSpinner";
import FileUpload from "../../common/FileUpload";
import {
  getStudentProfileForUpdateOnly,
  getStudentProfileByFormNumber,
  getPayableFeeForStudent,
  savePaymentRecords,
  resetStudentProfile,
  getRegistrationsByFilter,
  updateCollegeFeePaymentDetails
} from "../../api/admissionApi";
import { uploadSingleFileToS3 } from "../../api/fileUploadApi";
import RegistrationInfo from "./RegistrationInfo";
import moment from "moment";
import Popup from "../../Shared/Popup";



function RecordCollegeFees({ permissions = {}, isSuperAdmin }) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const {
    authenticationReducer: {
      isStudent,
      faculty_id
    } = {},
    admissionReducer: {
      isAdmissionsOpen = false,
      admissionPageInfo = {},
      isFetchingExistingAdmsnPageInfo = false,
      isUserProfileLoading = false,
      isAdmissionPageInfoLoaded = false,
      admissionPageInfoFailed,
      studentProfile = {},
      filteredReg = [],
      fetchingReg
    }
  } = state;

  const fileUploadRef = useRef(null);
  const [searchByFormNumber, setSearchByFormNumber] = useState("");
  const [searchByEmail, setSearchByEmail] = useState("");
  const [isStudentProfileFetched, setIsStudentProfileFetched] = useState(false);
  const [showStudentFullProfile, setShowStudentFullProfile] = useState(false);
  const [paymentConfirmationDocument, setPaymentConfirmationDocument] = useState("");
  const [payableFees, setPayableFees] = useState(0);
  const [payment_mode, setPaymentMode] = useState('demandDraft');
  const [openEventPopup, setopenEventPopup] = useState(false);
  const [customPopupTitle, setcustomPopupTitle] = useState("");
  const [customPopupContent, setcustomPopupContent] = useState();
  const [userPaymentInfo, setUserPaymentInfo] = useState({
    "isPaymentVerified": false,
    "transaction_number": "",
    "payment_mode": "",
    "payment_doc_url": "",
    "documents_verified": false,
    "verified_by":faculty_id,
    "formNumber": "",
    "total_fee_paid": ""
  });

  const getStudProfileByEmail = (email, cbs) => dispatch(getStudentProfileForUpdateOnly(email, cbs));
  const getStudProfileByFormNo = (formNumber, cbs) => dispatch(getStudentProfileByFormNumber(formNumber, cbs));
  const getPayableFee = (email, cbs) => dispatch(getPayableFeeForStudent({ email_id: email }, cbs));
  const savePaymentUpdatedRecords = (data, cbs) => dispatch(savePaymentRecords(data, cbs));
  const [selectedReg, setSelectedReg] = useState({});
  const [showRegInfo, setShowDDPhotos] = useState(false);
  const [isVerificationInProgress, setIsVerificationInProgress] = useState(false);



  const resetStuProfile = () => dispatch(resetStudentProfile());
  const completePayment = (data, cbs) =>
  dispatch(updateCollegeFeePaymentDetails(data, cbs));

  const { is_registration_completed, payment_status: { payment_mode: paymentMode = '', payment_doc_url = "", transaction_number = "", documents_verified, isPaymentVerified, doc_verification_date, payment_date, isCollegeFeePaid, collegeFeesPaidDate, roll_no_generate_date, student_id, student_id_generate_date } = {}, roll_number, creation_date,
        reg_complete_date, examination_status :{is_examination_passed = false, update_date} = {} } = studentProfile;

  useEffect(()=> {
    fetchDefaultList();
  }, [])

  const fetchDefaultList = () => {
    //if we want only the paid list of students
    const payload = {
        collegeFeeDDMode: true
    };
    dispatch(getRegistrationsByFilter(payload, errorCallback));

  //if we want complete list of paid and unpaid students
  // getAllStudentRegistrations(errorCallback);
  };
  const errorCallback = (err) => {
    if(err?.data?.registrations === "No registrations found with provided filters")  toast.error("No pending registrations found!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
  }

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Record college entrance fee payments</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Verify college entrance fee DD payments
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

const verifyDDPayment = (event, obj, ddNumber) => {
    event.preventDefault();
    event.stopPropagation();
    setIsVerificationInProgress(true);
    if(obj.formNumber && ddNumber && faculty_id){
        const requestPayload = {
            paymentMode: "DDVerified",
            formNumber: obj.formNumber,
            ddNumber: ddNumber,
            verified_by: faculty_id
        };
        console.log(requestPayload);
        const callbacks = {
            successCallback: completePaymentSuccessCallback,
            failureCallback: completePaymentFailureCallback,
        };
        completePayment(requestPayload, callbacks);
    } else if(!ddNumber) {
        alert("Enter DD number!");
    } else if(!obj.formNumber) {
        toast.error("Form number not available, please refresh!");
    }
};
const completePaymentSuccessCallback = (response) => {
    setIsVerificationInProgress(false);
    toast.success(response.message);
    setTimeout(() => fetchDefaultList(), 2500);
};
const completePaymentFailureCallback = (errData) => {
    setIsVerificationInProgress(false);
    toast.error(
    "Error updating DD payment, retry again!"
    );
    setTimeout(()=> window.location.reload(), 2500);
};


const cancelDDVerificationHandler = () => {
    setcustomPopupTitle("");
    setcustomPopupContent();
};


const renderRegistrations = () => {
    if (!filteredReg.length) return null;
    return (
    <div className="table-responsive card mt-20">{isVerificationInProgress && <LoaderSpinner />}
        <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
        <thead>
            <tr>
            <th style={{ borderRight: "1px solid #eee" }}>Form No.</th>
            <th style={{ borderRight: "1px solid #eee" }}>Name</th>
            <th style={{ borderRight: "1px solid #eee" }}>Email Id</th>
            <th style={{ borderRight: "1px solid #eee" }}>Phone</th>
            <th style={{ borderRight: "1px solid #eee" }}>Reg. completion date</th>
            <th style={{ borderRight: "1px solid #eee" }}>DD photos</th>
            {/* <th style={{ borderRight: "1px solid #eee" }}>DD back</th> */}
            <th style={{ borderRight: "1px solid #eee" }}>Verify payment</th>
            </tr>
        </thead>
        <tbody>
            {filteredReg.map((reg = {}, idx) => {
            const { formNumber, full_name: { first_name = '', last_name = '' } = {}, collegeFeeDDPayment_status: {collegeFeeDemandDraftFront = "", collegeFeeDemandDraftBack = ""} = {} } = reg;
            let ddNumber = [];
            return (
                <tr key={idx}>
                <td style={{ textAlign: "center", borderRight: "1px solid #eee" }}>{formNumber ? formNumber : '-'}</td>
                <td style={{ borderRight: "1px solid #eee" }}><span className="font-16">{`${first_name} ${last_name}`}</span></td>
                <td style={{ borderRight: "1px solid #eee" }}>{reg.email_id}</td>
                <td style={{ textAlign: "center", borderRight: "1px solid #eee" }}>{reg.mobile_number}</td>
                <td style={{ borderRight: "1px solid #eee" }}>
                    {reg.is_registration_completed && moment(reg.reg_complete_date?.date).format("YYYY-MM-DD HH:MM")}
                </td>
                <td style={{display: "flex",flexDirection: "column", gap: "15px", borderRight: "1px solid #eee" }}>
                    <button type="button" className="btn btn-outline-primary" onClick={() => window.open(collegeFeeDemandDraftFront, "_blank")}>Front</button>
                    <button type="button" className="btn btn-outline-primary" onClick={() => window.open(collegeFeeDemandDraftBack, "_blank")}>Back</button>
                </td>
                {/* <td style={{ borderRight: "1px solid #eee" }}>
                    <button type="button" className="btn btn-outline-primary" onClick={() => window.open(collegeFeeDemandDraftBack, "_blank")}>View</button>
                </td> */}
                <td>
                    <input
                        type="text"
                        className="form-control mb-3"
                        placeholder="DD number"
                        name="ddNumber"
                        value={ddNumber[idx]}
                        onChange={(e) => ddNumber[idx] = e.target.value}
                        onKeyUp={(e) => {
                        e.keyCode === 13 && verifyDDPayment(e, reg, ddNumber[idx]);
                        }}
                    />
                    <button
                        type="button"
                        className="btn btn-outline-success"
                        onClick={(e) => verifyDDPayment(e, reg, ddNumber[idx])}
                        >
                        Verify payment
                    </button>
                </td>
                <td>
                </td>
                </tr>
            );
            })}
        </tbody>
        </table>
    </div>
    );
}

const renderContent = () => {
return (
    <div className="card">
    <div className="card-header">
        <h3 className="card-title">Verify/Update college entrance fees DD (demand draft) payments</h3>
    </div>
    <div className="card-body">
        {fetchingReg ? <span>
            Loading...
            <LoaderSpinner />
        </span> : filteredReg.length > 0 ? <>
            <p>Below is the list of all pending registrations/requests waiting for the DD confirmation:</p>
            {renderRegistrations()}
        </> : <>
        No pending registrations/requests found.</>
        }
    </div>
    </div>
);
};

if (!isSuperAdmin && !permissions.read) {
return <NoPermission />;
}

  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
      {openEventPopup && (
          <Popup
            title={customPopupTitle}
            onCloseClick={() => setopenEventPopup(false)}
            content={customPopupContent}
          />
        )}
    </Fragment>
  );
}

export default RecordCollegeFees;
